const AuthRoutes = {
  login: "/login",
};

export default AuthRoutes;
